import { NgModule } from '@angular/core';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { CustomFormsModule } from 'ng2-validation';
import { NgxLoadingModule } from 'ngx-loading';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { LocalStorageService } from './storage/local-storage.service';
import { FormModule } from './form/form.module';
import { SessionTokenGuard } from './router/guard/session';
import { UiModule } from './ui/ui.module';
import { HttpModule } from './http/http.module';
import { MiscModule } from './misc/misc.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NouisliderModule } from 'ng2-nouislider';
import { UploadFactory } from './misc/service/upload.service';
import { AdminUrlBuilder } from './admin/api/admin-url-builder';
import { AdyenPlugin } from './payment/adyen/plugin';
import { HasUnsavedChangesGuard } from './router/guard/has-unsaved-changes-guard.service';
import { NgLetDirective } from './directives/ng-let.directive';
import { ApacheBarChartComponent } from './components/apache-bar-chart/apache-bar-chart.component';
import { ApacheVerticalChartComponent } from './components/apache-vertical-chart/apache-vertical-chart.component';
import { LoaderComponent } from './components/loader/loader.component';
import { InventoryUpdateStockModal } from '../module/admin/component/invetory/modals/inventory-datatable-update/inventory-datatable-update.component';
import { NoCurrencyFormatPipe } from './pipes/no-currency-format.pipe';

@NgModule({
    declarations: [
        NgLetDirective,
        ApacheBarChartComponent,
        ApacheVerticalChartComponent,
        LoaderComponent,
        InventoryUpdateStockModal,
        NoCurrencyFormatPipe,
    ],
    providers: [
        LocalStorageService,
        SessionTokenGuard,
        HasUnsavedChangesGuard,
        UploadFactory,
        AdminUrlBuilder,
        AdyenPlugin,
    ],
    imports: [
        CommonModule,
        FormModule,
        UiModule,
        HttpModule,
        Angular2PromiseButtonModule,
        CustomFormsModule,
        NgxLoadingModule,
        MiscModule,
        ProgressbarModule,
        FormsModule,
        NgxDatatableModule,
        ReactiveFormsModule,
        NouisliderModule,
    ],
    exports: [
        CommonModule,
        FormModule,
        UiModule,
        HttpModule,
        Angular2PromiseButtonModule,
        CustomFormsModule,
        NgxLoadingModule,
        MiscModule,
        ProgressbarModule,
        FormsModule,
        NgxDatatableModule,
        ReactiveFormsModule,
        NouisliderModule,
        NgLetDirective,
        ApacheBarChartComponent,
        ApacheVerticalChartComponent,
        LoaderComponent,
        InventoryUpdateStockModal,
        NoCurrencyFormatPipe,
    ],
})
export class SharedModule {}
